// extracted by mini-css-extract-plugin
module.exports = {"message":"SuccessMessage_message__1F9kd","greeting":"SuccessMessage_greeting__2vFTo"};